<template>
  <v-card class="" elevation="0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-select solo :items="allAccounts()" v-model="account" @input="accountFilter" append-icon="mdi-chevron-down"
          label="Account Types" class="custom-select" item-text="account_type_display" item-value="id"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3">
        <ul>
          <li class="mr-3 mr-lg-0">
            <span class="text--green">Total Amount:</span>
            <span class="text-right">${{ formattedAllNumber(totalAmount) }}</span>
          </li>
          <li class="mr-3 mr-lg-0">
            <span>Total Count:</span>
            <span class="text-right">{{ formattedAllNumber(pagination?.total) }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable depositTableForTransaction"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="creditin" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.account_fullname="{ item }" v-if="$canRoute('registered-user?tab=1') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.user_id}`">
                  {{ `${item.account_fullname} (${item?.user_id})` }}
                </router-link>
              </template>
              <template v-slot:item.account_fullname="{ item }" v-else>
                <span class="text-capitalize text--ash">
                  {{ `${item.account_fullname} (${item?.user_id})` }}
                </span>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>
              <template v-slot:item.account_email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.account_email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item?.account_email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.comment="{ item }">
                {{ item?.comment || "N/A" }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  TRANSACTIONS__ACTIONS,
  ACCOUNTTYPES__ACTIONS,
} from "@/store/action-types";
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      selectedStatus: null,
      modal: false,
      dialog: false,
      account: null,
      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Acc Type", value: "trading_account_type_display" },
        { text: "Email", value: "account_email" },
        { text: "Login", value: "user_id" },
        { text: "Amount", value: "amount" },
        { text: "Comment", value: "comment" },
      ],
      isCopied: false,
      copiedStates: {},
      date: null
    };
  },
  computed: {
    ...mapState("trxcreditin", [
      "creditin",
      "totalCount",
      "isLoading",
      "totalAmount",
      "pagination"
    ]),

    ...mapState("accounttypes", ["accounttypes"]),
    ...mapState("admins", ["loggedAdmin"]),
    isItOpen() {
      return function (item) {
        return item?.status !== 2;
      };
    },
  },
  methods: {
    formatMySQLDate,
    ...mapActions("trxcreditin", [TRANSACTIONS__ACTIONS.TRXCREDITIN]),
    ...mapActions("accounttypes", [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },
    allAccounts() {
      return [{ id: "All", account_type_display: "All" }, ...this.accounttypes];
    },

    getColor(item) {
      return item.color;
    },

    getTextColor(item) {
      return item.status === 1
        ? "text-approved"
        : item.status === 2
          ? "text-decline"
          : "text-pending";
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    copyText(item) {
      navigator.clipboard.writeText(item?.account_email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    async fetchData() {
      const params = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
        trading_account_type_id: this.account === "All" ? null : this.account,
      };

      if (this.selectedDates?.length === 2) {
        params.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[TRANSACTIONS__ACTIONS.TRXCREDITIN](params);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    accountFilter() {
      this.options.page = 1;
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData();
    await this[ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]();
  },
};
</script>
